/* eslint-disable */
export default {
  data() {
    return {
      setPage: false,
      show_list: false,
      itemsPerPage: 10
    }
  },
  methods: {
    set_por_paginas(itemsPerPage) {
      this.itemsPerPage = itemsPerPage
    },
  }
}
